import React, { useState } from "react";
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Divider, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OlympiadRegistrationPDF from "./modals/OlympiadRegistrationPDF";

const ViewOlympiadRegistrationModal = ({ closePopup, modalData }) => {
    const data = modalData?.data || modalData;
    const [modal, setModal] = useState(false);
    const [pdfData, setPdfData] = useState(null);

    const getClassNumber = (className) => {
        const match = className?.match(/\d+/);
        return match ? parseInt(match[0], 10) : 0;
    };

    // const formatDate = (date) =>
    //     date ? new Date(date).toLocaleString() : "N/A";
    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const formatDate2 = (dateStr) => {
        if (!dateStr) return "N/A";

        const date = new Date(dateStr);

        if (isNaN(date)) return "N/A";

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            // hour: "2-digit",
            // minute: "2-digit",
            // second: "2-digit",
            // hour12: true
        });
    };

    const uniqueCoordinators = [
        ...new Map(data?.coordinators?.map((c) => [c.email, c])).values()
    ];
    const groupedSubjects = data?.lineItems?.reduce((acc, item) => {
        const key = item.subjectName;

        if (!acc[key]) acc[key] = [];

        acc[key].push(item);

        return acc;
    }, {});

    const fetchOlympiadMOMSummaryAPI = async () => {
        try {

            console.log("Fetching MOM Summary API with:", {
                regId: data?.regId,
                partyId: data?.partyId
            });
            const result = await window.Platform.database.getMOMSummaryAPI({
                regId: data?.regId,
                partyId: data?.partyId
            });

            console.log("MOM Summary API Result:", result);

            if (result?.status && result?.data) {
                setPdfData(result.data);

                // ✅ FINAL PDF CALL
                OlympiadRegistrationPDF(result.data);
            } else {
                console.warn("No data from API");
            }

        } catch (err) {
            console.error("API Error:", err);
        }
    };
    const getStatusColor = (status) => {
        switch (status) {
            case "completed":
                return "success";

            case "pending":
                return "warning";

            default:
                return "default";
        }
    };
    return (
        // <Box p={2} sx={{ backgroundColor: "#fff", position: "relative" }}>
        <Box sx={{ backgroundColor: "#fff", height: "100%", display: "flex", flexDirection: "column" }}>

            <Box
                sx={{
                    position: "sticky",
                    top: -20,
                    zIndex: 10,
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #ddd",
                    px: 2,
                    py: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                {/* HEADER */}
                <Typography variant="h5">
                    <b style={{ color: "#000", fontWeight: "600", }}>Olympiad Details: - </b> <span style={{ color: "#000", fontWeight: "600", fontSize: "14px" }}>{data?.schoolName} ({data?.partyId})</span>
                </Typography>

                <IconButton
                    onClick={closePopup}
                // sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                {/* 🔹 Coordinators */}
                <Box mb={3}>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: 2,
                            backgroundColor: "#f8f9fa",
                            borderRadius: 2,
                            padding: 2.5,
                            border: "1px solid #e0e0e0",
                        }}
                    >
                        <Box>
                            <Typography variant="body2" sx={{ color: "#000" }}>
                                Olympiad Type
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {modalData?.olympiad_type_name || "N/A"}
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="body2" sx={{ color: "#000" }}>
                                Registration Type
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {modalData?.RegistrationType || "N/A"}
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="body2" sx={{ color: "#000" }}>
                                Registration Medium
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {modalData?.reg_medium_name || "N/A"}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="body2" sx={{ color: "#000" }}>
                                MOM Olympiad Date
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {formatDate2(modalData?.mom_olympiad_date)}
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="body2" sx={{ color: "#000" }}>
                                JPQ Olympiad Date
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {formatDate2(modalData?.jpq_olympiad_date)}
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="body2" sx={{ color: "#000" }}>
                                Registration ID
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {modalData?.rno_id || "N/A"}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box mb={3}>
                    <Typography mb={1}>
                        <b style={{ fontSize: "18px", fontWeight: "600", color: "#000" }}> Coordinator Details </b>
                    </Typography>

                    <Table size="small" sx={{ backgroundColor: "#fff" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>S.No</b></TableCell>
                                <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Subject</b></TableCell>
                                <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Coordinator Name</b></TableCell>
                                <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Mobile</b></TableCell>
                                <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Email</b></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data?.coordinators?.length > 0 ? (
                                data.coordinators.map((c, i) => (
                                    <TableRow key={c.id}>
                                        <TableCell sx={{ color: "#000", fontWeight: "600", }}>{i + 1}</TableCell>
                                        <TableCell sx={{ color: "#000", fontWeight: "600", }}>{c.subject_id == "9999" ? "General Coordinator" : c.subject_name || "N/A"}</TableCell>
                                        <TableCell sx={{ color: "#000", fontWeight: "600", }}>{c.name}</TableCell>
                                        <TableCell sx={{ color: "#000", fontWeight: "600", }}>{c.mobile}</TableCell>
                                        <TableCell sx={{ color: "#000", fontWeight: "600", }}>{c.email}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No Coordinator Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>

                <Divider sx={{ mb: 1 }} />
                <Card sx={{ mb: 4 }}>
                    <CardContent>

                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            mb={2}
                            color={"#000"}
                        >
                            Transaction Details
                        </Typography>

                        <Table size="small"
                            sx={{
                                border: "1px solid #000",
                                tableLayout: "fixed",
                                width: "100%",
                                "& .MuiTableCell-root": {
                                    border: "1px solid #000",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                    padding: "3px",
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                        Reference No.
                                    </TableCell>

                                    <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                        Payment Mode
                                    </TableCell>

                                    <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                        Total Amount
                                    </TableCell>

                                    <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                        Paid Amount
                                    </TableCell>

                                    <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                        Pending Amount
                                    </TableCell>

                                    <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                        Date
                                    </TableCell>

                                    <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                        Status
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>

                                {modalData?.transactions
                                    ?.map((reg, ind) => {

                                        return <TableRow key={reg?.key}>

                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>
                                                {reg?.transactionReference || "-"}
                                            </TableCell>

                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>
                                                {reg?.payment_mode || "-"}
                                            </TableCell>

                                            <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                                ₹ {reg?.totalAmount || 0}
                                            </TableCell>

                                            <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                                ₹ {reg?.paidAmount || 0}
                                            </TableCell>

                                            <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                                ₹ {reg?.pendingAmount || 0}
                                            </TableCell>

                                            <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                                {formatDate(reg?.transactionDate)}
                                            </TableCell>

                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={reg?.transactionStatus || "-"}
                                                    color={getStatusColor(reg?.transactionStatus)}
                                                />
                                            </TableCell>

                                        </TableRow>
                                    })}

                                {!modalData?.transactions?.length && (
                                    <TableRow>
                                        <TableCell
                                            colSpan={7}
                                            align="center"
                                        >
                                            No Transactions Found
                                        </TableCell>
                                    </TableRow>
                                )}

                            </TableBody>
                        </Table>

                    </CardContent>
                </Card>
                <Box>
                    <span>
                        <b style={{ fontSize: "15px", fontWeight: "600", color: "#000" }}>Transaction Remark</b> :-
                        <span style={{ fontSize: "13px", color: "#000", fontWeight: "600" }}> {modalData?.transactions[0]?.transaction_remark || "N/A"}</span>
                    </span>
                </Box>


                {/* 🔹 Line Items */}
                <Grid container spacing={2}>
                    {Object.entries(groupedSubjects || {}).map(([subject, items], idx) => {

                        const totalRegAmount = items.reduce(
                            (sum, i) => sum + ((i.student || 0) * (i.registrationFee || 0)),
                            0
                        );

                        const totalSMCount = items.reduce(
                            (sum, i) => sum + (Number(i.study_material) || 0),
                            0
                        );

                        const totalSMAmount = items.reduce(
                            (sum, i) =>
                                sum + ((Number(i.study_material) || 0) * (Number(i.subjectAmount) || 0)),
                            0
                        );

                        const grandTotal = totalRegAmount + totalSMAmount;

                        // totals
                        const totalStudents = items.reduce((sum, i) => sum + (Number(i.student) || 0), 0);

                        return (
                            <Grid item xs={12} key={idx}>
                                <Card sx={{ borderRadius: 2 }}>
                                    <CardContent>

                                        {/* 🔹 SUBJECT HEADER */}
                                        <Typography variant="h6" mb={1}>
                                            Subject: {subject}
                                        </Typography>

                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Class</b></TableCell>
                                                    <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Students</b></TableCell>
                                                    <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Registration Fee</b></TableCell>
                                                    <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Study Material</b></TableCell>
                                                    <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Study Material Count</b></TableCell>
                                                    <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Study Material Fee</b></TableCell>
                                                    <TableCell style={{ background: "#dce3dd", color: "#000", fontSize: "14px" }}><b>Amount</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* {items.map((item, i) => { */}
                                                {[...items]
                                                    .sort((a, b) => getClassNumber(a.className) - getClassNumber(b.className))
                                                    .map((item, i) => {

                                                        // const regAmount = (item.student || 0) * (item.registrationFee || 0);
                                                        // const smCount = item.study_material ? item.study_material : 0;
                                                        // const smAmount = smCount * (item.subjectAmount || 0);
                                                        // const totalAmount = Number(regAmount) + Number(smAmount);

                                                        const regAmount = (Number(item.student) || 0) * (Number(item.registrationFee) || 0);
                                                        const smCount = Number(item.study_material) || 0;
                                                        const smAmount = smCount * (Number(item.subjectAmount) || 0);
                                                        const totalAmount = regAmount + smAmount;

                                                        return (
                                                            <TableRow key={i}>
                                                                <TableCell sx={{ color: "#000", fontWeight: "600", }}>{item.className}</TableCell>

                                                                <TableCell sx={{ color: "#000", fontWeight: "600", }}>{item.student}</TableCell>

                                                                <TableCell sx={{ color: "#000", fontWeight: "600", }}>₹{regAmount}</TableCell>

                                                                <TableCell>
                                                                    <Chip
                                                                        label={item.study_material ? "Yes" : "No"}
                                                                        size="small"
                                                                        color={item.study_material ? "success" : "default"}
                                                                    />
                                                                </TableCell>

                                                                <TableCell sx={{ color: "#000", fontWeight: "600", }}>{smCount}</TableCell>

                                                                <TableCell sx={{ color: "#000", fontWeight: "600", }}>₹{smAmount}</TableCell>

                                                                <TableCell sx={{ color: "#000", fontWeight: "600", }}><b>₹{totalAmount}</b></TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                                    <TableCell><b>Total</b></TableCell>

                                                    <TableCell><b>{totalStudents}</b></TableCell>

                                                    <TableCell><b>₹{totalRegAmount}</b></TableCell>

                                                    <TableCell></TableCell>

                                                    <TableCell><b>{totalSMCount}</b></TableCell>

                                                    <TableCell><b>₹{totalSMAmount}</b></TableCell>

                                                    <TableCell><b>₹{grandTotal}</b></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>

                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={fetchOlympiadMOMSummaryAPI}
                    >
                        Download PDF
                    </Button>

                    <Button variant="contained" color="warning" onClick={closePopup}>
                        Close
                    </Button>
                </div>
            </Box>
        </Box>
    );
};

export default ViewOlympiadRegistrationModal;